import { Chip, useTheme } from '@material-ui/core';
import React, { useMemo } from 'react';
import { ColorX } from '../color/ColorX';
import { useThemeColor } from '../color/useThemeColor';

export type ChipXProps = {
	label: string;
	fill?: boolean;
	color?: ColorX;
	icon?: React.ReactElement;
	style?: React.CSSProperties;
	onClick?: VoidFunction;
	className?: string;
};

export const ChipX = ({ label, color = 'default', fill, icon, style, onClick, className }: ChipXProps) => {
	const theme = useTheme();
	const tColor = useThemeColor(color);
	// eslint-disable-next-line
	const cColor = useMemo(() => (color === 'success' ? theme.palette.primary.contrastText : theme.palette.getContrastText(tColor)), [color, tColor]);

	return (
		<Chip
			className={className}
			size='small'
			variant={fill === true ? 'default' : 'outlined'}
			icon={icon}
			style={{
				color: fill === true ? cColor : tColor,
				borderColor: tColor,
				backgroundColor: fill === true ? tColor : 'inherit',
				fontSize: '12px',
				height: '22px',
				width: 'fit-content',
				...style,
			}}
			onClick={onClick}
			label={<div style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>{label}</div>}
		/>
	);
};
